define('viewModels/privileged/composer/forms/formEditor/QuestionViewFactory',[
    'models/composer/forms/QuestionType',
    'viewModels/privileged/composer/forms/formEditor/MultipleChoiceQuestion'
], function (
    QuestionType,
    MultipleChoiceQuestionViewModel
) {
    'use strict';

    function QuestionViewModelFactory(/*question*/) {
        this.constructor = MultipleChoiceQuestionViewModel;
        return MultipleChoiceQuestionViewModel.apply(this, arguments);
    }

    return QuestionViewModelFactory;
});

